"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var services_1 = require("stremio/services");
var GamepadDiagram_1 = __importDefault(require("./GamepadDiagram"));
var styles_less_1 = __importDefault(require("./styles.less"));
var LEFT = '←';
var RIGHT = '→';
var UP = '↑';
var DOWN = '↓';
var LABELS = {
    playstation: {
        bottom: '✕', right: '○', left: '□', top: '△',
        lb: 'L1', rb: 'R1',
        lStick: 'L stick', rStick: 'R stick',
    },
    xbox: {
        bottom: 'A', right: 'B', left: 'X', top: 'Y',
        lb: 'LB', rb: 'RB',
        lStick: 'L stick', rStick: 'R stick',
    },
    generic: {
        bottom: '✕', right: '○', left: '□', top: '△',
        lb: 'L1', rb: 'R1',
        lStick: 'L stick', rStick: 'R stick',
    },
};
var GamepadModal = function (_a) {
    var _b;
    var onClose = _a.onClose;
    var t = (0, react_i18next_1.useTranslation)().t;
    var gamepad = (0, services_1.useGamepad)();
    var labels = LABELS[(_b = gamepad === null || gamepad === void 0 ? void 0 : gamepad.controllerType) !== null && _b !== void 0 ? _b : 'generic'];
    (0, react_1.useEffect)(function () {
        gamepad === null || gamepad === void 0 ? void 0 : gamepad.lock('gamepad-');
        var onKeyDown = function (_a) {
            var key = _a.key;
            key === 'Escape' && onClose();
        };
        document.addEventListener('keydown', onKeyDown);
        gamepad === null || gamepad === void 0 ? void 0 : gamepad.on('buttonB', 'gamepad-modal', onClose);
        return function () {
            document.removeEventListener('keydown', onKeyDown);
            gamepad === null || gamepad === void 0 ? void 0 : gamepad.off('buttonB', 'gamepad-modal');
            gamepad === null || gamepad === void 0 ? void 0 : gamepad.unlock();
        };
    }, [gamepad, onClose]);
    return (0, react_dom_1.createPortal)((react_1.default.createElement("div", { className: styles_less_1.default['gamepad-modal'], "data-gamepad-modal": true },
        react_1.default.createElement("div", { className: styles_less_1.default['backdrop'], onClick: onClose }),
        react_1.default.createElement("div", { className: styles_less_1.default['container'] },
            react_1.default.createElement("div", { className: styles_less_1.default['header'] },
                react_1.default.createElement("div", { className: styles_less_1.default['title'] }, t('GAMEPAD_CONTROLS_TITLE')),
                react_1.default.createElement(components_1.Button, { className: styles_less_1.default['close-button'], title: t('BUTTON_CLOSE'), onClick: onClose },
                    react_1.default.createElement(react_2.default, { className: styles_less_1.default['icon'], name: 'close' }))),
            react_1.default.createElement("div", { className: styles_less_1.default['content'] },
                react_1.default.createElement(GamepadDiagram_1.default, null),
                react_1.default.createElement("div", { className: styles_less_1.default['sections'] },
                    react_1.default.createElement("div", { className: styles_less_1.default['section'] },
                        react_1.default.createElement("div", { className: styles_less_1.default['section-title'] }, t('GAMEPAD_SECTION_NAVIGATION')),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.lStick),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_NAVIGATE'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.bottom),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_SELECT'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.right),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_BACK'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.top),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_FULLSCREEN'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.left),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_GUIDE'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.lb),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_PREV_TAB'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.rb),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_NEXT_TAB')))),
                    react_1.default.createElement("div", { className: styles_less_1.default['section'] },
                        react_1.default.createElement("div", { className: styles_less_1.default['section-title'] }, t('GAMEPAD_SECTION_PLAYER')),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.left),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_PLAY_PAUSE'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.rStick),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }, LEFT),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_SEEK_BACK'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.rStick),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }, RIGHT),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_SEEK_FWD'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.rStick),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }, UP),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_VOL_UP'))),
                        react_1.default.createElement("div", { className: styles_less_1.default['mapping'] },
                            react_1.default.createElement("kbd", { className: styles_less_1.default['kbd'] }, labels.rStick),
                            react_1.default.createElement("span", { className: styles_less_1.default['dir'] }, DOWN),
                            react_1.default.createElement("span", { className: styles_less_1.default['action'] }, t('GAMEPAD_ACTION_VOL_DOWN'))))))))), document.body);
};
exports.default = GamepadModal;
